import $ from 'jquery';

const SEEN_COOKIE = 'sawSoldFavourites';

export const FavouritesComponent = {
	bindings: {
	},
	templateUrl: 'favourites.html',
	transclude: true,
	controller: class FavouritesComponent {
		/**
		 * Init
		 */

		constructor($rootScope, favouriteService, $mdDialog,
			loginService, $cookies, messagingService, WebWalkService, notificationService, loaderService, $timeout, $filter) {
			'ngInject';
			this.$rootScope = $rootScope;
			this.favouritesService = favouriteService;
			this.$mdDialog = $mdDialog;
			this.model = {
				message: ''
			};
			this.loginService = loginService;
			this.$cookies = $cookies;
			this.messagingService = messagingService;
			this.webWalk = WebWalkService;
			this.notificationService = notificationService;
			this.loaderService = loaderService;
			this.$timeout = $timeout;
			this.$filter = $filter;
		}

		$onChanges() {
		}

		$onInit() {
			this.showCopyLink = !!document.execCommand && !!window.getSelection;
			if (this.$rootScope.isLoggedIn && !this.initialized) {
				if (!this.$cookies.get(SEEN_COOKIE)) {
					this.getSoldFavorites();
				}
				this.getFavourites();
			}
			this.notifications = {};
			this.initialized = true;
		}

		initSliders() {
			// let vm = this;
			// if (this.favouritesList && angular.element('.m36-slick-fav_' + this.favouritesList[0].property.comissionId).length) {
			// 	this.favouritesList.forEach(e => {
			// 		vm.lazyBgImg(true, 0, e);
			// 		angular.element('.m36-slick-fav_' + e.property.comissionId).on('init', (event, slick) => {
			// 			vm.lazyBgImg(angular.element(slick.$slides.get(0)), 0, e);
			// 		});
			// 		angular.element('.m36-slick-fav_' + e.property.comissionId).on('beforeChange', (event, slick, slide, nextSlide) => {
			// 			if (nextSlide != slide) {
			// 				vm.lazyBgImg(angular.element(slick.$slides.get(nextSlide)), nextSlide, e);
			// 			}
			// 		});
			// 	});
			// } else {
			// 	vm.$timeout(() => {
			// 		vm.initSliders();
			// 	}, 300);
			// }
		}

		lazyBgImg(element, nextSlide, e) {
			if (element) {
				let lazyBgImgs = angular.element('.m36-slick-fav_' + e.property.comissionId + '_' + nextSlide);
				$.each(lazyBgImgs, function (index, el) {
					$(el).css('background-image', 'url(' + e.property.images[nextSlide].url + ')');
				});
			}
		}

		/**
		 * Rests
		 */

		getSoldFavorites() {
			this.favouritesService.getSoldFavourites().then((response) => {
				this.soldFavourites = response.data;
				if (this.soldFavourites.length) {
					this.openSoldFavouritesModal();
				}
				this.$cookies.put(SEEN_COOKIE, new Date());
			}).catch(() => {
				this.notificationService.showError({
					message: 'technicalError'
				});
			});
		}

		getFavourites(params) {
			this.loaderService.show();
			this.favouritesService.getFavourites(params).then((response) => {
				this.loaderService.hide();
				this.responseData = response.data;
				this.favouritesList = this.responseData.content;
				this.favouritesList.forEach(e => {
					e.property.images = this.$filter('picOrderFilter')(e.property.images);
				});
				this.totalElements = this.responseData.totalElements;
				this.size = this.responseData.size;
				this.setTags(this.favouritesList);
				this.webWalk.setWebWalkProperty(this.favouritesList);
				this.initSliders();
			}).catch(() => {
				// mock
				/* this.responseData = {content:[{id:31, createDateTime:'2018-07-16 06:07:54', comment:null, property:{comissionId:'M82817', comissionType:'toSell', city:'Salgótarján', district:null, address:'fő út mellet', priceHuf:13900000, area:135.0, siteArea:1455.0, numberOfRooms:5, numberOfHalfRooms:1, lat:48.096226128770674, lng:19.78172859160444, hasHiddenAddress:true, url:'/ingatlan/M82817/elado-csaladi-haz-3102-salgotarjan-fo-ut-mellet', priceChange:null, images:[], offers:[], seen:true, liked:false, likedMorePeople:false, active:true}}, {id:29, createDateTime:'2018-07-16 05:52:23', comment:null, property:{comissionId:'M110093', comissionType:'toSell', city:'Érd', district:null, address:'Postástelep', priceHuf:25500000, area:48.4, siteArea:null, numberOfRooms:3, numberOfHalfRooms:2, lat:47.395701, lng:18.911265, hasHiddenAddress:true, url:'/ingatlan/M110093/elado-lakas-2030-erd-postastelep', priceChange:null, images:[], offers:[], seen:false, liked:false, likedMorePeople:false, active:true}}, {id:28, createDateTime:'2018-07-16 05:52:19', comment:null, property:{comissionId:'M109958', comissionType:'toSell', city:'Érd', district:null, address:'Postástelep', priceHuf:25900000, area:50.6, siteArea:null, numberOfRooms:2, numberOfHalfRooms:1, lat:47.395701, lng:18.911265, hasHiddenAddress:true, url:'/ingatlan/M109958/elado-lakas-2030-erd-postastelep', priceChange:null, images:[], offers:[], seen:false, liked:false, likedMorePeople:false, active:true}}], number:0, numberOfElements:3, totalElements:3, totalPages:1, size:5};
				this.favouritesList = this.responseData.content;

				this.favouritesList[0].property.images = [{
					url: '/static/assets/sitebuild/img/career-01.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/career-02.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/career-03.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://www.realestate.com.au/blog/images/1885x1414-fit,progressive/2018/02/26012408/investing-property-with-superannuation_2000x1500.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}];

				this.favouritesList[1].property.images = [{
					url: '/static/assets/sitebuild/img/ingatlan-02.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-03.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-04.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-05.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}];

				this.favouritesList[2].property.images = [{
					url: 'https://www.hindustantimes.com/rf/image_size_640x362/HT/p2/2016/11/15/Pictures/dream-house-front_8843d09c-ab15-11e6-b961-04ee4fa7b706.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://cms.homeaway.com/files/live/sites/hub/files/contributed/homepage/marketing/list-your-property.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://d27p8o2qkwv41j.cloudfront.net/wp-content/uploads/2017/08/shutterstock_516637903-e1504758036917.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}];

				this.totalElements = this.responseData.totalElements;
				this.size = this.responseData.size;
				this.setTags(this.favouritesList);
				this.webWalk.setWebWalkProperty(this.favouritesList);
				this.initSliders();
				*/
				this.loaderService.hide();
				this.notificationService.showError({
					message: 'technicalError'
				});
			});
		}

		saveComment() {
			let params = {
				comment: this.model.message
			};
			this.favouritesService.saveComment(params, this.selectedFavourite.id).then((response) => {
				this.favouritesList[this.selectedFavouriteIndex] = response.data;
				this.closePopup();
			}).catch(() => {
				this.selectedFavourite.comment = params.comment;
				this.notificationService.showError({
					message: 'technicalError'
				});
				this.closePopup();
			});
		}

		deleteFromFavourites() {
			window.dataLayer.push({
				event: 'deleteLikedProperty',
				propertyID: this.selectedFavourite.property.comissionId
			});
			let id = this.selectedFavourite.id;
			this.favouritesService.deleteItem(id).then(() => {
				this.getFavourites();
				this.notifications = {
					message: 'Sikeres törlés.'
				};
			}).catch((err) => {
				console.log(err);
				this.notifications = {
					message: 'Hiba a törlés közben.'
				};
			});
		}

		deleteAllFavourites() {
			this.favouritesService.deleteAll().then(() => {
				this.getFavourites();
				this.closePopup();
			}).catch(() => {
				this.notificationService.showError({
					message: 'technicalError'
				});
				this.closePopup();
			});
		}

		deleteAllSold() {
			let params = {
				ids: ''
			};
			let arr = [];
			let comissionArray = [];
			for (let i = 0; i < this.soldFavourites.length; i++) {
				arr.push(this.soldFavourites[i].id);
				comissionArray.push(this.soldFavourites[i].property.comissionId);
			}
			params.ids = arr.join(',');
			let analyticsParam = comissionArray.join(',');
			window.dataLayer.push({
				event: 'deleteSoldProperty',
				propertyID: analyticsParam
			});
			this.favouritesService.deleteSome(params).then(() => {
				this.notifications.message = 'Sikeres törlés';
				this.getFavourites();
			}).catch(() => {
				this.notifications.message = 'Sikertelen törlés';
			});
		}

		/**
		 * Popups
		 */

		showAddComment($event, favourite, $index) {
			$event.preventDefault();
			this.selectedFavourite = favourite;
			this.selectedFavouriteIndex = $index;
			this.$mdDialog.show({
				templateUrl: 'favourite-comment-modal.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl'
			}).finally(() => {
				this.model.message = '';
			}).catch(() => {
			});
		}

		showEditComment($event, favourite, $index) {
			this.model.message = favourite.comment;
			this.showAddComment($event, favourite, $index);
		}

		showDeleteComment($event, favourite, $index) {
			$event.preventDefault();
			this.selectedFavourite = favourite;
			this.selectedFavouriteIndex = $index;
			this.$mdDialog.show({
				templateUrl: 'favourite-comment-delete-modal.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl'
			}).finally(() => {
				this.model.message = '';
			}).catch(() => {
			});
		}

		showDeleteFromFavouritesModal($event, favourite) {
			$event.preventDefault();
			this.selectedFavourite = favourite;
			this.$mdDialog.show({
				templateUrl: 'favourite-delete-from-list-modal.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl'
			});
		}

		showDeleteAllModal($event) {
			$event.preventDefault();
			this.$mdDialog.show({
				templateUrl: 'favourite-delete-all-modal.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl'
			});
		}

		openSoldFavouritesModal() {
			this.$mdDialog.show({
				templateUrl: 'favourite-sold-modal.html',
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl'
			});
		}

		closePopup(type) {
			this.model.message = '';
			this.notifications = {};
			this.$mdDialog.cancel();
		}

		/**
		 * Lapozó
		 */

		loadPage(event) {
			this.pager(event.pageTo, this.size);
		}

		pager(page, size) {
			let params = {
				page: page,
				size: size
			};
			this.getFavourites(params);
		}

		/**
		 * Kb util
		 */

		getDateTime(createDateTime) {
			// safari miatt a Date.parse helyett: https://stackoverflow.com/questions/6427204/date-parsing-in-javascript-is-different-between-safari-and-chrome
			let a = createDateTime.split(/[^0-9]/);
			return new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
		}

		setTags(list) {
			if (Array.isArray(list) && list.length) {
				for (let i = 0; i < list.length; i++) {
					let item = list[i];
					item.isSold = this.getIsSold(item.property);
					if (!item.isSold) {
						item.hasNewBid = this.getHasNewBid(item.property);
						if (!item.hasNewBid) {
							//
						} else {
							continue;
						}
					} else {
						continue;
					}
				}
			}
		}

		getIsSold(property) {
			if (property.offers.length) {
				return property.offers.some((element) => {
					return element.isSold;
				});
			} else {
				return false;
			}
		}

		getHasNewBid(property) {
			return property.offers.length >= 1;
		}

		/**
		 * SHARE
		 */

		copyToClipboard(domId, favourite) {
			window.dataLayer.push({
				event: 'copyPropertyLink',
				propertyID: favourite.property.comissionId
			});

			var $element = angular.element('#' + domId);
			$element[0].innerHTML = window.location.origin + favourite.property.url;
			var range = document.createRange();
			range.selectNode($element[0]);
			window.getSelection().addRange(range);
			document.execCommand('copy');
			// clear selection
			if (window.getSelection) {
				if (window.getSelection().empty) {  // Chrome
					window.getSelection().empty();
				} else if (window.getSelection().removeAllRanges) {  // Firefox
					window.getSelection().removeAllRanges();
				}
			} else if (document.selection) {  // IE?
				document.selection.empty();
			}
		}

		sendMail($event) {
			this.shareResponse = '';
			this.shareResponseError = '';
			let params = {
				emailAddress: $event.share.emailAddress,
				name: $event.share.name,
				url: $event.share.fav.property.url,
				lang: $event.share.lang,
				from: $event.share.from,
				comissionId: $event.share.fav.property.comissionId
			};
			this.messagingService.sendMessageToPerson(params, $event.share.captcha).then(() => {
				this.shareResponse = true;
			}).catch(() => {
				this.shareResponseError = true;
			});
		}

		openLoginForm($event) {
			this.loginService.openLoginForm($event);
		}

		openRegistrationForm() {
			this.loginService.openRegistrationForm();
		}

		newSearch($event) {
			$event.preventDefault();
			$event.stopPropagation();
			setTimeout(() => {
				window.location.href = angular.element($event.target).attr('href');
			}, 500);
		}

		compare($event) {
			$event.preventDefault();
			$event.stopPropagation();
			setTimeout(() => {
				window.location.href = angular.element($event.target).attr('href');
			}, 500);
		}

		navigateToProperty($event, url) {
			$event.preventDefault();
			$event.stopPropagation();
			if (url && !angular.element($event.target).is(':button')) {
				window.location.href = url;
			}
		}
	}
};
